module.exports = __webpack_public_path__ + "img/Butterfly_00042.65abc438.png";